import React from 'react';
import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import * as Image from 'core/img';

const spin = keyframes`
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
`;

const Spinner = () => {
	return (
		<Box
			position='relative'
			width='32'
			height='32'
		>
			<Box
				position={'absolute'}
				inset={0}
				animation={`${spin} 1s linear infinite`}>
				<Image.SpinnerCircle width={128} height={128} />
			</Box>

			<Box
				position={'absolute'}
				inset={0}
				display={'flex'}
				alignItems={'center'}
				justifyContent={'center'}
			>
				<Image.AgoraLogo width={48} height={48} />
			</Box>
		</Box>
	);
};

export default Spinner;